import script from "./PredictView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PredictView.vue?vue&type=script&setup=true&lang=ts"

import "./PredictView.vue?vue&type=style&index=0&id=4163fa40&lang=css"

const __exports__ = script;

export default __exports__